import React, { Component } from "react";
import {
  Button, Card, CardBody, Col, Container, Row,
} from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import {
  addServiceProvider,
  deleteServiceProvider,
  getServiceProvidersList,
} from "../../../store/service-provider/actions";
import { INITIAL_DATA_PARAMS } from "../../../constants/store";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class ServiceProviders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
    };
  }

  componentDidMount() {
    this.props.getServiceProvidersList({
      ...INITIAL_DATA_PARAMS,
    });
  }

  componentDidUpdate(prevProps, prevState) {
  }


  handleTableChange = data => {
    this.props.getServiceProvidersList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleAddServiceProvider = () => {
    this.props.history.push(`/service-providers/add`);
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.counterparty_name}"!`,
          onConfirm: () => {
            this.props.deleteServiceProvider(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row);
      };

      return (
        <React.Fragment>
          {!!this.props.permissions?.["change_serviceprovidermodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {!!this.props.permissions?.["delete_serviceprovidermodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row)}>{row[label]}</NameLink>
      );
    };

    const columns = [
      {
        dataField: "counterparty_name",
        text: "Counterparty name",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "counterparty_name"),
      },
      {
        dataField: "contract_number",
        text: "Contract number",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "contract_number"),
      },
      {
        dataField: "date_of_signature",
        text: "Date of signature",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "date_of_signature"),
      },
      {
        dataField: "expiration",
        text: "Expiration",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "expiration"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    const onClickRow = (e, row) => {
      this.props.history.push(`/service-providers/${row.id}`);
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Service Providers | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Service Providers"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this service provider? <br /> If you are not
                  sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading_list}
                    >
                      {!!this.props.permissions?.["add_serviceprovidermodel"] && (
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={this.toggleAddServiceProvider}
                        >
                          <i className="mdi mdi-plus me-1" /> Add service provider
                        </Button>
                      )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

ServiceProviders.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  loading_list: PropTypes.bool.isRequired,
  getServiceProvidersList: PropTypes.func.isRequired,
  addServiceProvider: PropTypes.func.isRequired,
  deleteServiceProvider: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  data: state.ServiceProviders.data,
  loading_list: state.ServiceProviders.loading_list,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getServiceProvidersList,
  addServiceProvider,
  deleteServiceProvider,
})(ServiceProviders);
